import { useEffect, useRef, useState } from "react";
import { api, errDetail } from "../lib/api";
import { Pulse, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function Activate() {
  const [status, setStatus] = useState({ type: "pending", message: "Activating your account…" });
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setStatus({ type: "error", message: "Activation token is missing from the link." });
      return;
    }
    api.post("/auth/activate", { token })
      .then(({ data }) => setStatus({ type: "success", message: `Account ${data.email} activated! You can now sign in.` }))
      .catch((e) => setStatus({ type: "error", message: errDetail(e) }));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-sm border border-border bg-card p-8 space-y-5 text-center" data-testid="activate-page">
        <div className="flex items-center justify-center gap-2">
          <Pulse size={26} weight="bold" className="text-primary" />
          <h1 className="font-heading font-bold text-2xl tracking-tight">My trading journal</h1>
        </div>
        {status.type === "success" && <CheckCircle size={40} weight="bold" className="text-profit mx-auto" />}
        {status.type === "error" && <XCircle size={40} weight="bold" className="text-loss mx-auto" />}
        <p className={`text-sm ${status.type === "success" ? "text-profit" : status.type === "error" ? "text-loss" : "text-muted-foreground"}`}
          data-testid="activate-status">
          {status.message}
        </p>
        {status.type !== "pending" && (
          <a href="/" data-testid="activate-goto-login"
            className="inline-block text-sm text-primary hover:underline">Go to sign in</a>
        )}
      </div>
    </div>
  );
}
